<template>
    <div>
        <ubi-panel>
            <el-container>
                <el-aside width="25%"><h3>{{ $t("posts.edit.rentalTitle") }}</h3>
                    <p class="text-justify">{{ $t("posts.edit.fillAdPriceDetails") }}</p></el-aside>
                <el-container>
                    <el-main>
                        <el-col :span="24" v-if="post.loyer_est_cc === 'oui'">
                            <el-form-item label="Loyer mensuel (toutes charges comprises) *"
                                          prop="loyer_mensuel"
                                          >
                                <el-input
                                    type="text"
                                    inputmode="decimal"
                                    autocomplete="off"
                                    :value="montantDisplay('loyer_mensuel')"
                                    @focus="() => onMontantFieldFocus('loyer_mensuel')"
                                    @input="v => onMontantTextInput('loyer_mensuel', v)"
                                    @blur="() => onMontantFieldBlur('loyer_mensuel')"
                                    clearable>
                                    <template slot="append">{{getDevise}} / {{ $t("general.month") }}</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24" v-else>
                            <el-form-item label="Loyer mensuel *"
                                          prop="loyer_mensuel"
                                          >
                                <el-input
                                    type="text"
                                    inputmode="decimal"
                                    autocomplete="off"
                                    :value="montantDisplay('loyer_mensuel')"
                                    @focus="() => onMontantFieldFocus('loyer_mensuel')"
                                    @input="v => onMontantTextInput('loyer_mensuel', v)"
                                    @blur="() => onMontantFieldBlur('loyer_mensuel')"
                                    clearable>
                                    <template slot="append">{{getDevise}} / {{ $t("general.month") }}</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item :label="$labels.complement_loyer + ' ' + $t('posts.edit.includingTaxes')"
                                          prop="complement_loyer"
                                          >
                                <el-input
                                    type="text"
                                    inputmode="decimal"
                                    autocomplete="off"
                                    :value="montantDisplay('complement_loyer')"
                                    @focus="() => onMontantFieldFocus('complement_loyer')"
                                    @input="v => onMontantTextInput('complement_loyer', v)"
                                    @blur="() => onMontantFieldBlur('complement_loyer')"
                                    clearable>
                                    <template slot="append">{{getDevise}} / {{ $t("general.month") }}</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item :label="$labels.loyer_de_base" prop="loyer_de_base">
                                <el-input
                                    type="text"
                                    inputmode="decimal"
                                    autocomplete="off"
                                    :value="montantDisplay('loyer_de_base')"
                                    @focus="() => onMontantFieldFocus('loyer_de_base')"
                                    @input="v => onMontantTextInput('loyer_de_base', v)"
                                    @blur="() => onMontantFieldBlur('loyer_de_base')"
                                    clearable>
                                    <template slot="append">{{getDevise}} / {{ $t("general.month") }}</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item :label="$labels.zone_encadrement_loyer">
                                <el-radio v-model="post.zone_encadrement_loyer" label="oui">{{ $t("general.yes") }}</el-radio>
                                <el-radio v-model="post.zone_encadrement_loyer" label="non">{{ $t("general.no") }}</el-radio>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24" v-if="post.loyer_est_cc === 'non'">
                          <el-form-item :label="$labels.charges_locatives">
                            <el-input
                                type="text"
                                inputmode="decimal"
                                autocomplete="off"
                                :value="montantDisplay('charges_locatives')"
                                @focus="() => onMontantFieldFocus('charges_locatives')"
                                @input="v => onMontantTextInput('charges_locatives', v)"
                                @blur="() => onMontantFieldBlur('charges_locatives')"
                                clearable>
                              <template slot="append">{{getDevise}} / {{ $t("general.month") }}</template>
                            </el-input>
                          </el-form-item>
                        </el-col>
<!--                        Si c'est un commerce -->
                        <span v-if="post.typeObjet >= 2000 && post.typeObjet < 3000">
                            <el-col :span="24">
                                <el-form-item :label="$t('posts.loyer_an_m2')"
                                              prop="loyer_ht_hc_m2_an"
                                >
                                    <el-input  v-mask="'#################'" v-model.number="post.loyer_ht_hc_m2_an" type="loyer_ht_hc_m2_an">
                                        <template slot="append">{{getDevise }}/m²/{{ $t("general.year") }}</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <!-- UBI-328 / #116523 — loyer annuel HT (def 2276), espace ancien uniquement -->
                            <el-col :span="24" v-if="isEspaceAncien" data-test="post-form-loyer-an-est-ht">
                                <el-form-item :label="$labels.loyer_an_est_ht">
                                    <el-radio-group v-model="post.loyer_an_est_ht" @change="onLoyerAnEstHtChange">
                                        <el-radio label="oui">{{ $t("general.yes") }}</el-radio>
                                        <el-radio label="non">{{ $t("general.no") }}</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                        </span>
                        <el-col :span="24">
                            <el-form-item :label="$t('posts.edit.recoveryCondition')">
                                <el-select
                                        v-model="post.modalites_recuperation_charges_locatives"
                                        :placeholder="$t('posts.edit.selectTypePlaceholder')"
                                        clearable
                                        filterable
                                >
                                    <el-option
                                            style="text-transform:capitalize"
                                            v-for="modaliteRecuperationChoice in this.$parent.getChoices('modalites_recuperation_charges_locatives')"
                                            :key="modaliteRecuperationChoice"
                                            :label="modaliteRecuperationChoice"
                                            :value="modaliteRecuperationChoice"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item :label="$t('posts.edit.rentalFeeIncludingConditionInspection')"
                                          >
                                <el-input v-model="post.honoraires_location" step="0.01" type="number">
                                    <template slot="append">{{getDevise}}</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item :label="$labels.honoraires_etat_des_lieux + ' ' + $t('posts.edit.includingTaxes')"
                                          >
                                <el-input v-model="post.honoraires_etat_des_lieux" step="0.01" type="number">
                                    <template slot="append">{{getDevise}}</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item :label="$labels.loyer_reference_majore + ' ' + $t('posts.edit.includingTaxes')"
                                          >
                                <el-input v-model="post.loyer_reference_majore" step="0.01" type="number">
                                    <template slot="append">{{getDevise}}</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24" v-if="isBailleurSocial && post">
                            <el-form-item :label="$t('posts.edit.location_active')">
                                <el-radio v-model="post.location_active" label="oui">{{ $t("general.yes") }}</el-radio>
                                <el-radio v-model="post.location_active" label="non">{{ $t("general.no") }}</el-radio>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24" v-if="isBailleurSocial && post">
                            <el-form-item :label="$t('posts.edit.location_active_nud')">
                                <el-radio v-model="post.location_active_nud" label="oui">{{ $t("general.yes") }}</el-radio>
                                <el-radio v-model="post.location_active_nud" label="non">{{ $t("general.no") }}</el-radio>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                          <el-form-item :label="$t('posts.securityDeposit')">
                            <el-input
                                type="text"
                                inputmode="decimal"
                                autocomplete="off"
                                :value="montantDisplay('depot_garantie')"
                                @focus="() => onMontantFieldFocus('depot_garantie')"
                                @input="v => onMontantTextInput('depot_garantie', v)"
                                @blur="() => onMontantFieldBlur('depot_garantie')"
                                clearable>
                              <template slot="append">{{getDevise}}</template>
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item :label="$t('posts.edit.linkToAgencyFees')">
                                <el-input v-model="post.url_tarifs_publics">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item :label="$labels.duree_du_bail"
                                          prop="duree_du_bail"
                                          >
                                <el-input  v-mask="'#################'" v-model.number="post.duree_du_bail" type="duree_du_bail">
                                    <template slot="append">{{ $t('general.month') }}</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item :label="$t('posts.edit.collateralSecurityRequired')">
                                <el-radio v-model="post.organisme_foncier_solidaire" label="oui">{{ $t("general.yes") }}</el-radio>
                                <el-radio v-model="post.organisme_foncier_solidaire" label="non">{{ $t("general.no") }}</el-radio>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24" v-if="post.organisme_foncier_solidaire == 'oui'">
                            <el-form-item :label="$labels.montant_caution_solidaire"
                                          prop="montant_caution_solidaire"
                                         >
                                <el-input  v-mask="'#################'" v-model.number="post.montant_caution_solidaire" type="montant_caution_solidaire">
                                    <template slot="append">{{getDevise}}</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item :label="$labels.pour_investisseur">
                                <el-radio v-model="post.pour_investisseur" label="oui">{{ $t("general.yes") }}</el-radio>
                                <el-radio v-model="post.pour_investisseur" label="non">{{ $t("general.no") }}</el-radio>
                            </el-form-item>
                        </el-col>
<!--                      Colocation-->
                        <el-col :span="24">
                            <el-form-item :label="$labels.colocation">
                                <el-radio v-model="post.colocation" label="oui">Oui</el-radio>
                                <el-radio v-model="post.colocation" label="non">Non</el-radio>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24" v-if="post.colocation === 'oui'">
                            <el-form-item :label="$labels.surface_privee_colocation">
                                <el-input
                                    v-model="post.surface_privee_colocation"
                                    type="number"
                                    clearable>
                                    <template slot="append">m²</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24" v-if="post.colocation === 'oui'">
                          <el-form-item :label="$labels.id_regroupement_annonces">
                            <el-input
                                v-model="post.id_regroupement_annonces"
                                type="text"
                                :placeholder="$t('posts.edit.idRegroupementAnnoncesPlaceholder')"
                                clearable>
                            </el-input>
                          </el-form-item>
                        </el-col>
                    </el-main>
                </el-container>
            </el-container>
        </ubi-panel>
        <ubi-panel>
            <el-container>
                <el-aside width="25%"><h3>{{ $t("posts.edit.copropertyTitle") }}</h3>
                    <p class="text-justify">{{ $t("posts.edit.fillCopropertyInformation") }}</p>
                </el-aside>
                <el-container>
                    <el-main>
                        <el-col :span="24">
                            <el-form-item :label="$labels.copropriete">
                                <el-radio v-model="post.copropriete" label="oui">{{ $t("general.yes") }}</el-radio>
                                <el-radio v-model="post.copropriete" label="non">{{ $t("general.no") }}</el-radio>
                            </el-form-item>
                        </el-col>
                      <el-col :span="24" v-if="(isBailleurSocial || isAgence) && post.copropriete === 'oui'">
                        <el-form-item :label="$labels.alur_syndic_en_procedure" >
                          <el-radio v-model="post.alur_syndic_en_procedure" label="oui">{{ $t("general.yes") }}</el-radio>
                          <el-radio v-model="post.alur_syndic_en_procedure" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                      </el-col>
                        <el-col :span="24" v-if="post.copropriete == 'oui' ">
                            <el-form-item :label="$labels.alur_nb_lots">
                                <el-input v-model="post.alur_nb_lots">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24" v-if="post.copropriete == 'oui' ">
                            <el-form-item :label="$t('posts.edit.copropertyMonthlyFee')">
                                <el-input v-model="post.charges_copropriete">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24" v-if="post.copropriete == 'oui' ">
                            <el-form-item :label="$labels.alur_copropriete_plan_de_sauvegarde">
                                <el-radio v-model="post.alur_copropriete_plan_de_sauvegarde" label="oui">{{ $t("general.yes") }}</el-radio>
                                <el-radio v-model="post.alur_copropriete_plan_de_sauvegarde" label="non">{{ $t("general.no") }}</el-radio>
                            </el-form-item>
                        </el-col>
                    </el-main>
                </el-container>
            </el-container>
        </ubi-panel>
      <ubi-panel v-if="!isCmiste && !isEspacil">
        <el-container>
          <el-aside width="25%"><h3>{{ $t("posts.edit.mandateTitle") }}</h3>
            <p class="text-justify">{{ $t("posts.edit.fillMandateInformation") }}</p></el-aside>
          <el-container>
            <el-main>
              <el-row>
                <el-col :span="12">
                  <el-form-item :label="$labels.mandat_type">
                    <el-radio-group v-model="post.mandat_type">
                      <el-radio
                          v-for="mandatTypeChoice in this.$parent.getChoices('mandat_type')"
                          :key="mandatTypeChoice"
                          :label="mandatTypeChoice"
                          :value="mandatTypeChoice">
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item :label="$labels.mandat_statut">
                    <div style="font-size: 12px;">
                      <el-button class="el-icon-error reset-radio"
                       v-if="post.mandat_statut != '' && post.mandat_statut != undefined && post.mandat_statut != null"
                       @click="post.mandat_statut = null"
                       circle>
                      </el-button></div>
                    <el-radio-group v-model="post.mandat_statut">
                      <el-radio
                          v-for="madantStatutChoice in this.$parent.getChoices('mandat_statut')"
                          :key="madantStatutChoice"
                          :label="madantStatutChoice"
                          :value="madantStatutChoice">
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="post.mandat_statut=='vendu par l\'agence' || post.mandat_statut=='compromis' ">
                <el-col lg="24">
                  <el-form-item :label="$labels.date_compromis">
                    <el-date-picker
                        v-model="post.date_compromis"
                        format="dd/MM/yyyy"
                        value-format="dd/MM/yyyy"
                        :placeholder="$labels.date_compromis">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="block">
                    <el-form-item :label="$labels.date_mandat">
                      <el-date-picker
                          v-model="post.date_mandat"
                          format="dd/MM/yyyy"
                          value-format="dd/MM/yyyy"
                          :placeholder="$labels.date_mandat">
                      </el-date-picker>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="block">
                    <el-form-item :label="$labels.mandat_echeance">
                      <el-date-picker
                          v-model="post.mandat_echeance"
                          format="dd/MM/yyyy"
                          value-format="dd/MM/yyyy"
                          :placeholder="$labels.mandat_echeance">
                      </el-date-picker>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item :label="$labels.mandat_numero">
                    <el-input v-model="post.mandat_numero">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item :label="$labels.vente_intercabinet">
                    <el-checkbox
                        v-model="post.vente_intercabinet" true-label="oui" false-label="non"></el-checkbox>
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="post.vente_intercabinet =='oui' || post.intercabinet_repartition_honoraires != null">
                  <el-form-item :label="$t('posts.edit.intercabinetCommission')">
                    <el-input   v-mask="'#################'" v-model.number="post.intercabinet_repartition_honoraires">
                      <div slot="append">%</div>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item :label="$labels.proprietaire_nom + ' ' + $t('posts.edit.withoutCivilityAndName')">
                    <el-input v-model="post.proprietaire_nom">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item :label="$labels.proprietaire_tel_dom">
                    <el-input v-model="post.proprietaire_tel_dom">
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$labels.proprietaire_tel_bur">
                    <el-input v-model="post.proprietaire_tel_bur">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item :label="$t('posts.edit.landlordAddress')">
                    <el-input v-model="post.proprietaire_adresse1">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item :label="$labels.proprietaire_code_postal">
                    <el-autocomplete
                        class="inline-input"
                        v-model="post.proprietaire_code_postal"
                        :fetch-suggestions="this.$parent.searchPostal"
                        @select="this.$parent.selectPostalProprietaire"></el-autocomplete>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$labels.proprietaire_ville">
                    <el-input v-model="post.proprietaire_ville">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :md="12" :xs="24">
                  <el-form-item :label="$t('posts.edit.realPropertyPostalCode')">
                    <el-autocomplete
                        class="inline-input"
                        v-model="post.code_postal_reel"
                        :fetch-suggestions="this.$parent.searchPostal"
                        @select="this.$parent.selectPostalReel"></el-autocomplete>
                  </el-form-item>
                </el-col>
                <el-col :md="12" :xs="24">
                  <el-form-item :label="$t('posts.edit.realPropertyCity')">
                    <el-input v-model="post.ville_reelle"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item :label="$t('posts.edit.landlordOtherInformation')">
                    <el-input v-model="post.proprietaire_commentaire" type="textarea" :rows="5">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-main>
          </el-container>
        </el-container>
      </ubi-panel>
    </div>
</template>

<script>
import { getDefinitionDonneeListeeByCode } from '@/services/posts'
import { mapGetters } from 'vuex'
import montantDecimalInput from '@/mixins/montantDecimalInput'

export default {
  name: 'PostEditImmoOfferL',
  mixins: [montantDecimalInput],
  props: ['post', 'ddList'],
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['isBailleurSocial', 'isAgence']),
    getDevise () {
      return this.$store.getters['donnees/getDevise']
    },
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    userJob () {
      return this.sitimmoUser.metier
    },
    isCmiste () {
      return this.userJob === 'CMI'
    },
    isPromoteur () {
      return this.userJob === 'PROMOTEUR'
    },
    isEspacil () {
      return (this.sitimmoUser.id == '353182')
    },
    isEspaceAncien () {
      return !this.isCmiste && !this.isPromoteur
    }
  },
  methods: {
    // Si le loyer annuel est HT, aligner le booléen mensuel (def 2746) — alternative ticket #116523
    onLoyerAnEstHtChange (value) {
      if (value === 'oui' && this.post) {
        this.$set(this.post, 'loyer_mensuel_est_ht', 'oui')
      }
    }
  },
  async beforeMount () {
    let codes = ['modalites_recuperation_charges_locatives', 'mandat_statut', 'mandat_type']

    codes = codes.map(function (x) { return x.toUpperCase() })
    const definitionDonneeListeeByCode = await getDefinitionDonneeListeeByCode({ codes: codes })
    if (definitionDonneeListeeByCode.type === 'error') {
      this.$message({ message: this.$t('error.found'), type: 'error' })
      this.loading = false
      return false
    }
    this.$emit('ddList-update', definitionDonneeListeeByCode)
  }
}
</script>
